import React from "react";
import { AllDestinations } from "../../../../../models";
import { formatDateUS } from "../../../../../utils";

export const DestinationCreatedColumn = ({
  destination,
}: {
  destination: AllDestinations;
}) => {
  return (
    <div className="truncate overflow-hidden">
      {formatDateUS(destination.createdAt!)}
    </div>
  );
};
